const l = {
  name: "Airline",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M30,40h-2.3L20,35.2L12.3,40H10v-5.5l6-5l-0.3-6L0,29.4v-5.9l15.2-13.2c0-3.2,0.8-6.3,2.4-9
			C18.1,0.5,19,0,20,0c1,0,1.9,0.5,2.4,1.3c1.6,2.7,2.5,5.8,2.4,9L40,23.5v5.9l-15.7-5.9l-0.3,6l6,5V40z M24.4,21.4L38,26.5v-2.1
			L24.7,12.9L24.4,21.4z M15.3,12.9L2,24.4v2.1l13.6-5.1L15.3,12.9z M20,32.8L20,32.8L20,32.8l8,5v-2.4l-6-5l0.8-19.7
			c0.1-3-0.6-5.9-2.1-8.4c-0.3-0.5-1-0.5-1.3,0c-1.5,2.5-2.3,5.4-2.1,8.4L18,30.4l-6,5v2.4L20,32.8L20,32.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Airline
};
